export default __webpack_public_path__ + "static/media/lap_image9.7160c692.webp";